import { Component, OnInit } from '@angular/core';
import { HomeCrmResumo } from 'app/interfaces/home-crm-resumo';
import { HomeProcesso } from 'app/interfaces/home-processo';
import { HomeOportunidadeOferta } from 'app/interfaces/home-oportunidade-oferta';
import { PeriodoFiltroDashboard } from 'app/interfaces/enum/periodo-filtro-dashboard';
import { Usuario } from 'app/interfaces/usuario';

import { ParceiroHttpService } from 'app/main/parceiro/parceiro-http.service';
import { ProcessoHttpService } from 'app/main/processo/processo-http.service';
import { OportunidadeOfertaHttpService } from 'app/main/oportunidadeoferta/oportunidadeoferta-http.service';

import { MessageService } from 'app/utils/toastr-custom/message.service';
import handleErrorMessage from 'app/utils/error-message-handler';
import { OportunidadeOfertaTrHttpService } from 'app/main/oportunidadeofertatr/oportunidadeoferta-tr-http.service';
import { ProcessoTrHttpService } from 'app/main/processotr/processo-tr-http.service';
import { ParametroHttpService } from 'app/main/parametro/parametro-http.service';
import { SessionStorageService } from 'app/utils/session-storage.service';

@Component({
  selector: 'app-home-transporte-rodoviario',
  templateUrl: './home-transporte-rodoviario.component.html',
  styleUrls: ['./home-transporte-rodoviario.component.scss'],
})
export class HomeTransporteRodoviarioComponent implements OnInit {

  carregando = false;
  carregandoOferta = true;
  carregandoProcesso = true;
  usuario: Usuario;
  nomeUsuario = '';
  razaoSocial: string;

  resumo: HomeCrmResumo = {
    totalContas: 0,
    suspects: 0,
    prospects: 0,
    leads: 0,
    clientesAtivos: 0,
    percentualClientesAtivos: 0,
  };

  labelPeriodoProcesso = 'Últimos 30 dias';
  labelPeriodoOferta = 'Últimos 30 dias';

  periodoFiltro = PeriodoFiltroDashboard;

  semDadosOferta = false;
  semDadosProcesso = false;

  private getDescricaoStatusProcesso(status?: string): string {
    switch (status) {
      case 'EM_ANDAMENTO':
        return 'Em andamento';

      case 'AUDITADO':
        return 'Auditado';

      case 'CANCELADO':
        return 'Cancelado';

      case 'FINALIZADO_CONTABILMENTE':
        return 'Finalizado contabilmente';

      case 'FINALIZADO_OPERACIONALMENTE':
        return 'Finalizado operacionalmente';

      case 'AGUARDANDO_PROGRAMACAO':
        return 'Aguardando programação';

      case 'PROGRAMACAO_REALIZADA':
        return 'Programação realizada';

      default:
        return status ?? '-';
    }
  }


  constructor(
    private _sessionStorageService: SessionStorageService,
    private _parceiroHttpService: ParceiroHttpService,
    private _processoTrHttpService: ProcessoTrHttpService,
    private _oportunidadeOfertaTrHttpService: OportunidadeOfertaTrHttpService,
    private _parametroHttpService: ParametroHttpService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.carregarUsuario();
    this.getRazaoSocial();
    this.getResumoCrm();
    this.getInformacaoGraficoProcessoRodoviario();
    this.getInformacaoGraficoOportunidadeOfertasRodoviario();
  }

  private carregarUsuario(): void {
    const usuarioSessao = this._sessionStorageService.getItem('user');

    if (!usuarioSessao) {
      return;
    }

    this.usuario = JSON.parse(usuarioSessao) as Usuario;
    this.nomeUsuario = this.usuario?.nome ?? '';
  }

  getRazaoSocial(): void {
    this._parametroHttpService.getParametroByName('PARAM_RAZAO_SOCIAL').subscribe({
      next: result => {
        this.razaoSocial = result.valor;
      },
      error: error => handleErrorMessage(this._messageService, error),
    });
  }

  getResumoCrm(): void {
    this.carregando = true;

    this._parceiroHttpService.getResumoHomeCrm().subscribe({
      next: (resumo: HomeCrmResumo) => {
        this.resumo = resumo;
        this.atualizarGraficoCrm();
        this.carregando = false;
      },
      error: error => {
        this.carregando = false;
        handleErrorMessage(this._messageService, error);
      },
    });
  }

  filtroPeriodoOfertas(dias: number): void {
    this.labelPeriodoOferta = `Últimos ${dias} dias`;

    const hoje = new Date();
    const inicio = new Date();

    inicio.setDate(hoje.getDate() - dias);

    const dataInicial = inicio.toISOString().substring(0, 10);
    const dataFinal = hoje.toISOString().substring(0, 10);

    this.getInformacaoGraficoOportunidadeOfertasRodoviario(
      dataInicial,
      dataFinal
    );
  }

  filtroPeriodoProcesso(dias: number): void {
    this.labelPeriodoProcesso = `Últimos ${dias} dias`;

    const hoje = new Date();
    const inicio = new Date();

    inicio.setDate(hoje.getDate() - dias);

    const dataInicial = inicio.toISOString().substring(0, 10);
    const dataFinal = hoje.toISOString().substring(0, 10);

    this.getInformacaoGraficoProcessoRodoviario(
      dataInicial,
      dataFinal
    );
  }

  getInformacaoGraficoProcessoRodoviario(
    dataInicial?: string,
    dataFinal?: string
  ): void {
    this.carregandoProcesso = true;

    this._processoTrHttpService
      .getInformacaoGraficoProcessoRodoviario(dataInicial, dataFinal)
      .subscribe({
        next: (result: HomeProcesso[]) => {
          this.donutChartProcesso = {
            ...this.donutChartProcesso,
            series: result.map(item => item.quantidade ?? 0),
            labels: result.map(item => this.getDescricaoStatusProcesso(item.status)),
          };

          this.semDadosProcesso =
            result.length === 0 ||
            this.donutChartProcesso.series.every((valor: number) => valor === 0);

          this.carregandoProcesso = false;
        },
        error: error => {
          this.carregandoProcesso = false;
          this.semDadosProcesso = true;
          handleErrorMessage(this._messageService, error);
        },
      });
  }

  getInformacaoGraficoOportunidadeOfertasRodoviario(
    dataInicial?: string,
    dataFinal?: string
  ): void {
    this.carregandoOferta = true;

    this._oportunidadeOfertaTrHttpService
      .getInformacaoGraficoOportunidadeOfertasRodoviario(dataInicial, dataFinal)
      .subscribe({
        next: (result: HomeOportunidadeOferta[]) => {
          this.donutChartOferta = {
            ...this.donutChartOferta,
            series: result.map(item => item.quantidade ?? 0),
            labels: result.map(item => this.getDescricaoStatusOferta(item.status)),
          };

          this.semDadosOferta =
            result.length === 0 ||
            this.donutChartOferta.series.every((valor: number) => valor === 0);

          this.carregandoOferta = false;
        },
        error: error => {
          this.carregandoOferta = false;
          this.semDadosOferta = true;
          handleErrorMessage(this._messageService, error);
        },
      });
  } F

  private getDescricaoStatusOferta(status?: string): string {
    switch (status) {
      case 'REPROVADO':
        return 'Reprovado';

      case 'APROVADO':
        return 'Aprovado';

      case 'AGUARDANDO_PRICING':
        return 'Aguardando Pricing';

      case 'AGUARDANDO_PARCEIRO':
        return 'Aguardando Parceiro';

      case 'P2':
        return 'P2';

      case 'PRE_PROPOSTA':
        return 'Pré Proposta';

      case 'OFERTA_DISPONIVEL_PARA_ENVIO':
        return 'Oferta disponível para envio';

      case 'EM_ANDAMENTO':
        return 'Em andamento';

      default:
        return status ?? '-';
    }
  }

  private atualizarGraficoCrm(): void {
    this.funilChart = {
      ...this.funilChart,

      series: [
        this.resumo.suspects,
        this.resumo.prospects,
        this.resumo.leads,
        this.resumo.clientesAtivos,
      ],

      plotOptions: {
        ...this.funilChart.plotOptions,

        pie: {
          ...this.funilChart.plotOptions.pie,

          donut: {
            ...this.funilChart.plotOptions.pie.donut,

            labels: {
              ...this.funilChart.plotOptions.pie.donut.labels,

              total: {
                show: true,
                label: 'Contas',
                formatter: () =>
                  `${this.resumo.totalContas}`,
              },
            },
          },
        },
      },
    };
  }

  funilChart: any = {
    series: [],

    chart: {
      type: 'donut',
      height: 285,
    },

    labels: [
      'Suspects',
      'Prospects',
      'Leads',
      'Clientes ativos',
    ],

    colors: [
      '#82868B',
      '#FF9F43',
      '#00CFE8',
      '#28C76F',
    ],

    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '12px',

      formatter: function (
        seriesName: string,
        opts: any
      ) {
        const value =
          opts.w.globals.series[
          opts.seriesIndex
          ];

        return `${seriesName}: ${value}`;
      },
    },

    dataLabels: {
      enabled: false,
    },

    stroke: {
      width: 0,
    },

    plotOptions: {
      pie: {
        donut: {
          size: '70%',

          labels: {
            show: true,

            name: {
              show: true,
            },

            value: {
              show: true,
            },

            total: {
              show: true,
              label: 'Contas',
              formatter: () => '0',
            },
          },
        },
      },
    },
  };

  donutChartProcesso: any = {
    series: [],

    chart: {
      type: 'donut',
      height: 350,
    },

    labels: [
      'Em andamento',
      'Aguardando programação',
      'Programação realizada',
      'Finalizado operacionalmente',
      'Auditado',
      'Finalizado contabilmente',
    ],

    colors: [
      '#0F62AC',
      '#00CFE8',
      '#28C76F',
      '#FF9F43',
      '#82868B',
      '#512DA8',
    ],

    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '12px',

      formatter: function (
        seriesName: string,
        opts: any
      ) {
        const value =
          opts.w.globals.series[
          opts.seriesIndex
          ];

        return `${seriesName}: ${value}`;
      },
    },

    dataLabels: {
      enabled: true,

      formatter: function (val: number) {
        return `${val.toFixed(0)}%`;
      },
    },

    tooltip: {
      y: {
        formatter: function (val: number) {
          return val;
        },
      },
    },

    stroke: {
      width: 0,
    },
  };

  donutChartOferta: any = {
    series: [],

    chart: {
      type: 'donut',
      height: 350,
    },

    labels: [
      'Aprovado',
      'Reprovado',
      'P2',
      'Aguardando Pricing',
      'Aguardando Parceiro',
      'Pré Proposta',
      'Oferta Disponível para Envio',
    ],

    colors: [
      '#001F4D',
      '#003A80',
      '#0052B8',
      '#006FE6',
      '#1549A5',
      '#3B88D1',
      '#5C9FD6',
    ],

    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '12px',

      formatter: function (
        seriesName: string,
        opts: any
      ) {
        const value =
          opts.w.globals.series[
          opts.seriesIndex
          ];

        return `${seriesName}: ${value}`;
      },
    },

    dataLabels: {
      enabled: true,

      formatter: function (val: number) {
        return `${val.toFixed(0)}%`;
      },
    },

    tooltip: {
      y: {
        formatter: function (val: number) {
          return val;
        },
      },
    },

    stroke: {
      width: 0,
    },
  };
}
